import tempMeeApi from '../../../apis/tempMee';

/**
 * Takes an applied promo code back from an office:
 * `DELETE /v1/admin/offices/:officeId/applied-codes/:campaignId`
 * (campaign-service PR #159, GOTU-8100). Needs the admin's
 * `campaign:manage_promo_codes` claim.
 *
 * Idempotent: 204 whether the code was revoked now, was already revoked, or
 * was never held. The revoked application stays on the admin history, marked
 * with who took it back and when; the office's own list drops it.
 */
export const removeOfficePromoCode = async (officeId, campaignId) => {
  await tempMeeApi.delete(
    `/campaign-service/v1/admin/offices/${officeId}/applied-codes/${campaignId}`,
  );
};
